import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Users, Trophy, Calendar } from "lucide-react";

const PastHackathons: React.FC = () => {
	const pastEvents = [
		{
			id: "2024-winter",
			title: "大船渡ハッカソン 2024 Winter",
			date: "2024年2月24日-25日",
			participants: 28,
			winners: [
				{
					title: "グランプリ",
					team: "チームA",
					project: "高齢者見守りシステム",
				},
				{
					title: "準グランプリ",
					team: "チームB",
					project: "地域特産品マッチング",
				},
			],
			tags: ["防災", "高齢化", "地域活性化"],
			imageUrl: "/images/hackathon-2024-winter.jpg",
		},
		{
			id: "2023-summer",
			title: "大船渡ハッカソン 2023 Summer",
			date: "2023年7月22日-23日",
			participants: 24,
			winners: [
				{
					title: "グランプリ",
					team: "チームC",
					project: "観光ガイドアプリ",
				},
				{
					title: "準グランプリ",
					team: "チームD",
					project: "地域イベント管理システム",
				},
			],
			tags: ["観光", "地域活性化", "DX"],
			imageUrl: "/images/hackathon-2023-summer.jpg",
		},
	];

	return (
		<section className="py-16">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<h2 className="text-3xl font-bold mb-4 text-center">過去の開催実績</h2>
				<p className="text-gray-600 text-center mb-12">
					これまでの開催内容とその成果
				</p>
				<div className="grid md:grid-cols-2 gap-8">
					{pastEvents.map((event) => (
						<Card key={event.id}>
							<CardHeader>
								<div className="flex flex-wrap gap-2 mb-4">
									{event.tags.map((tag) => (
										<Badge key={tag} variant="secondary">
											{tag}
										</Badge>
									))}
								</div>
								<CardTitle>{event.title}</CardTitle>
								<CardDescription>
									<div className="flex items-center gap-4 mt-2">
										<div className="flex items-center gap-1">
											<Calendar className="w-4 h-4" />
											<span>{event.date}</span>
										</div>
										<div className="flex items-center gap-1">
											<Users className="w-4 h-4" />
											<span>{event.participants}名参加</span>
										</div>
									</div>
								</CardDescription>
							</CardHeader>
							<CardContent>
								<div className="mb-4">
									<div className="flex items-center gap-2 mb-2">
										<Trophy className="w-4 h-4 text-purple-600" />
										<span className="font-semibold">受賞プロジェクト</span>
									</div>
									<ul className="space-y-2">
										{event.winners.map((winner) => (
											<li key={winner.title} className="text-sm text-gray-600">
												<span className="font-medium">{winner.title}:</span>{" "}
												{winner.team} 「{winner.project}」
											</li>
										))}
									</ul>
								</div>
								<Button asChild variant="outline" className="w-full">
									<Link to={`/hackathon/archive/${event.id}`}>詳細を見る</Link>
								</Button>
							</CardContent>
						</Card>
					))}
				</div>
				<div className="text-center mt-8">
					<Button asChild variant="outline">
						<Link to="/hackathon/archive">過去の開催一覧を見る</Link>
					</Button>
				</div>
			</div>
		</section>
	);
};

export default PastHackathons;
